// ProductVariantEditorFeesSection.tsx
import React from 'react';
import { useFormikContext } from 'formik';
import { IVariantInitialValuesProps } from '../../views/Product/types';
import ProductFeesSection from '../../views/Product/sections/ProductFeesSection';

export interface IProductVariantEditorFeesSectionProps {
    disabled?: boolean;
}

export const ProductVariantEditorFeesSection: React.FC<IProductVariantEditorFeesSectionProps> = ({
    disabled = false,
}) => {
    const { values } = useFormikContext<IVariantInitialValuesProps>();

    return (
        <>
            {!disabled && (
                <ProductFeesSection
                    variant={values.variant}
                    hideTerms={true}
                    hideTitle={true}
                />
            )}
        </>
    );
};

